/**
 * CalEventStates — lifecycle states for a CalEvent.
 * Mirrors backend enum KD8.CalendarEvents.Data.Plugin.Models.CalendarEventStates.
 */
export const CalEventStates = {
    /** All CalendarEvents that have date/time in the future */
    Active: 0,

    /** CalendarEvent time is in the past — show notification or dialog for snooze/complete */
    Overdue: 100,

    /** Notification/dialog visible for user — can dismiss or snooze */
    Visible: 500,

    /** Set to completed by user — removed from upcoming list */
    Completed: 900,

    /** Marked for deletion from db and caches */
    Deleted: 999,
};
